/**
 * Link component integrated with React Router for client-side navigation.
 * Uses React Router's Link for internal navigation and regular anchor tags for external links.
 */

import * as Headless from '@headlessui/react'
import React, { forwardRef } from 'react'
import { Link as RouterLink } from 'react-router-dom'

export const Link = forwardRef(function Link(
  props: { href: string } & React.ComponentPropsWithoutRef<'a'>,
  ref: React.ForwardedRef<HTMLAnchorElement>
) {
  const { href, ...rest } = props
  
  // Check if it's an external link
  const isExternal = href.startsWith('http') || href.startsWith('mailto:') || href.startsWith('tel:')
  
  return (
    <Headless.DataInteractive>
      {isExternal ? (
        // eslint-disable-next-line jsx-a11y/anchor-has-content
        <a href={href} {...rest} ref={ref} />
      ) : (
        <RouterLink to={href} {...rest} ref={ref} />
      )}
    </Headless.DataInteractive>
  )
})
